<template>
	<div class="">
    <div class="" @touchmove.prevent>
      <div class="pt10 mt30">
        <a class="logo" href="/"><img src="static/images/logo.png" /></a>
      </div>
    </div>

   <!-- <div class="account-top ar mr10" @click="getAcount()"  @click.stop>
      <img src="static/images/account-icon2.png" v-if="isShow">
      <img src="static/images/account-icon.png" v-else>
    </div> -->
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              search:'',
              isShow:false,
              isActive:'/',
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,

            }
        },
        mounted() {
          if(this.$route.query.url){
            this.isActive = this.$route.query.url
          }else{
            this.isActive = '/'
          }
          if(localStorage.getItem('token')){
            this.isLogin = true
          }
          document.addEventListener("click", this.bodyCloseMenus);
         },
         beforeDestroy() {
           document.removeEventListener("click", this.bodyCloseMenus);
          },
		methods: {
      bodyCloseMenus(e) {
         let self = this;
          if (self.isShow == true){
           self.isShow = false;
          }
        },
			showMenu(item){
				let that =this;
				this.isActive = item.url;
        this.$router.push({path:item.url,query:{url:item.url}});
			},
			getAcount(){
				let that =this;
        this.$router.push({path:'/menu'})
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	//this.isShow = false;
      	this.$refs.saveDialog.showMaskFun();
      },
      // 弹框保存
      saveModal (){
        let that =this;
      	//this.$refs.saveDialog.closeMask();
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/unsubscribe',null,r =>{
        	//that.$parent.returnCode(r,function(){
            that.$utils.alertText(r.msg,80,3000);
            that.$parent.$parent.loadModal(false);
            if(r.code==1){
              localStorage.removeItem('token')
              this.$router.push({path:'/subscribe',query:{}});
            }else{
              this.$refs.saveDialog.closeMask();
            }
          //});
        })
      }
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/HeaderTwo.vue